export default "__VITE_ASSET__Cx6SqzDK__"